import axios from "../axios.js";
import { Cookies } from 'react-cookie'

const endPoint = `/copoun`
const cookie = new Cookies()
const token = await cookie.get('user')
export const applying = async (code) => {
    return await axios.post(`${endPoint}/apply-copoun`,{ code },{headers: { authorization: token }})
}



